const STORAGE_KEY = "aq_faq_recent_v1";
const RECENT_LIMIT = 8;
const CHANGE_EVENT = "aq-faq-recent-changed";

function safeParse(raw) {
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function readFaqRecent() {
  if (typeof window === "undefined") return [];
  return safeParse(window.localStorage.getItem(STORAGE_KEY))
    .filter((item) => item && item.id && item.title)
    .slice(0, RECENT_LIMIT);
}

export function pushFaqRecent(entry) {
  if (typeof window === "undefined" || !entry?.id || !entry?.title) return readFaqRecent();

  const nextItem = {
    id: String(entry.id),
    type: entry.type === "ask" ? "ask" : "faq",
    title: String(entry.title).trim().slice(0, 160),
    module: String(entry.module || "").trim(),
    mainModule: String(entry.mainModule || entry.module || "").trim(),
    subModule: String(entry.subModule || "").trim(),
    faqId: String(entry.faqId || "").trim(),
    chatSessionId: String(entry.chatSessionId || "").trim(),
    updatedAt: Date.now(),
  };

  const prev = readFaqRecent().filter((item) => item.id !== nextItem.id);
  const next = [nextItem, ...prev].slice(0, RECENT_LIMIT);
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: next }));
  return next;
}

export function subscribeFaqRecent(handler) {
  if (typeof window === "undefined") return () => {};
  const onStorage = (event) => {
    if (event.key && event.key !== STORAGE_KEY) return;
    handler(readFaqRecent());
  };
  const onCustom = (event) => {
    handler(Array.isArray(event.detail) ? event.detail : readFaqRecent());
  };
  window.addEventListener("storage", onStorage);
  window.addEventListener(CHANGE_EVENT, onCustom);
  return () => {
    window.removeEventListener("storage", onStorage);
    window.removeEventListener(CHANGE_EVENT, onCustom);
  };
}

export function buildFaqRecentId(faq) {
  const faqId = String(faq?.faqId || "").trim();
  if (faqId) return `faq:${faqId}`;
  return `faq:${String(faq?.question || "")
    .trim()
    .toLowerCase()
    .slice(0, 80)}`;
}

export function buildAskRecentId(moduleName, question) {
  return `ask:${String(moduleName || "")
    .trim()
    .toLowerCase()}:${String(question || "")
    .trim()
    .toLowerCase()
    .slice(0, 80)}`;
}
